import React, {useState, useEffect} from "react";
import {Link,useParams} from 'react-router-dom';
import moment from 'moment';
import { getData } from '../../config/api-connect';
import {  Table, Select, Spin, Breadcrumb,Input,Button  } from 'antd';
import { ArrowRightOutlined, HomeOutlined, UserOutlined,SearchOutlined,FilterFilled } from '@ant-design/icons';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'
import {toProperCase} from '../../utils/stringUtil.js'
import {getSearchFilter} from '../../utils/filterHelper.jsx'

const { Option } = Select;

const NewCustomers = () => {
	var today = new Date();
  var {monthYear} = useParams()
  var splitMonthYear = monthYear.split('-')
  var local_month = splitMonthYear[0] || '';
  var local_year = splitMonthYear[1] || '';

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

  const [loading, setLoading] = useState(true)
  const [selectedMonth, setSelectedMonth] = useState(local_month)
  const [selectedYear, setSelectedYear] = useState(local_year)
  const [cityId, setCityId] = useState(local_city)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [venuelist, setVenuelist] = useState([])
  const [newCustomersData,setNewCustomersData] = useState([])
  const [gameType, setGameType] = useState(local_game_type)

  useEffect(() => {
    if(cityId !== ''){
      setLoading(true)
      getNewCustomers()
    }
  }, [selectedMonth,selectedYear]); 

  const getNewCustomers = () => {
  	setLoading(true)
    getData(`/business/get_new_customers_drilldown/?month=${selectedMonth}&year=${selectedYear}
      &venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}`)
    .then(response =>{
       setNewCustomersData(response.results);
    })
    .catch(error => {
      console.log(error.message);
    })
    .finally(()=>{
      setLoading(false)
    })
  }

  const renderHeader = (title) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: 'bold',textWrap:'nowrap' }}>{title}</div>
    )
  }  

  const getDropdownFilter = (dataIndex) => ({
    filters: [...new Set(newCustomersData.map(item => item[dataIndex]).filter(v => v))].map(v => ({ text: v, value: v })),
    onFilter: (value, record) => record[dataIndex] === value,
    filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#1890ff' : '' }} />,
  });

  const getDateSorter = (dataIndex) => ({
    sorter: (a, b) => moment(a[dataIndex]).valueOf() - moment(b[dataIndex]).valueOf(),
  });

  const sampleData = newCustomersData[0] || {};

	const columns = Object.keys(sampleData).map((key) => ({
	  title: renderHeader(toProperCase(key)),
	  dataIndex: key,
	  align: 'center',
    ...((key === 'customer' || key === 'mobile') ? getSearchFilter(key, toProperCase(key)) : {}),
    ...((key === 'status') ? getDropdownFilter(key) : {}),
    ...((key === 'start_date' || key === 'end_date' || key === 'customer_from' || key === 'customer_to')  ? getDateSorter(key) : {}),
	}));

  const combinedMonthYear = () => {
    const dateString = `${selectedYear}-${selectedMonth}`
    return moment(dateString, 'YYYY-MM').format('MMMM YYYY')
  } 

	return(
		<Spin spinning={loading} indicator={<Spinner />}>
			<Styled.MainContainer>
				<Styled.TopDiv>    
          <Breadcrumb style={{padding:'10px'}} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/retention-analysis">
                <UserOutlined />
                <span style={{paddingLeft:'5px'}}>Retention Analysis</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item> 
            	<span>New Customers</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Styled.TopDiv>

        <Styled.Header>  
          <span> New Customers {'- ' + combinedMonthYear()}</span>
        </Styled.Header>
        <div className="recordCount">{newCustomersData?.length || 0} records</div>
        <div>
        	<Table
            className="drill-down-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={newCustomersData}
            pagination={{ pageSize: 50, showSizeChanger: false}}
          />
        </div>
			</Styled.MainContainer>
		</Spin>
	)
}

export default NewCustomers;	